var rw = {
    rwUtils: {
        manualUpdateDataTable: function(columns, aaData, jsObject, tableId) {
            var columnsTitle = [];
            console.log(columns, columns.length);
            for (var i = 0; i < columns.length; i++) {
                columnsTitle.push({title: columns[i]});
            }

            jsObject.fnClearTable();
            jsObject.fnDestroy();
            $(tableId).DataTable(
                {
                    data: aaData,
                    columns: columnsTitle
                }
            );
        },
        /**
         * Flash Message
         *
         * @param status : danger , success , info
         * @param msg : string
         * @param removeAll : remove last msgs
         */
        flashMessage: function (status, msg, removeAll) {
            var flash_messages ;
            if (status === "success") {
                flash_messages = {success: msg};
            } else if (status === "danger") {
                flash_messages = {danger: msg};
            } else {
                flash_messages = {info: msg};
            }

            var flash_msgs = new flashMessage("flashMessage", flash_messages, 12000);

            if (removeAll === true) {
                $('#flashMessage .alert').hide();
            }

            flash_msgs.showMessages();
        },

        /**
         * Check object is iterable or not
         *
         * @param object
         * @returns {boolean}
         */
        isIterable: function (object) {
            var prototype = Object.prototype.toString.call(object);
            var iterables = ['[object Array]', '[object Object]'];

            return (iterables.indexOf(prototype) !== -1);
        },

        /**
         * Functionalize Json
         *
         * @param _data
         * @returns {*}
         */
        functionalizeJson: function (_data) {
            var data = JSON.parse(JSON.stringify(_data));
            if (rw.rwUtils.isIterable(data)) {
                for (var name in data) {
                    fnDecomposer = /^\s*function\s*\(((?:\s*\w+\s*\,?)*)\)\s*\{([\s\S]+)\}\s*$/;
                    if (
                        Object.prototype.toString.call(data[name]) == '[object String]'
                        && fnDecomposer.test(data[name])
                    ) {
                        fnDecomposedArray = fnDecomposer.exec(data[name]);
                        fnArguments = fnDecomposedArray[1].split(',').map(function (v) {
                            return v.trim();
                        });
                        fnBody = fnDecomposedArray[2];

                        fnDetails = fnArguments;
                        fnDetails.push(fnBody);
                        data[name] = Function.apply(this, fnDetails);
                    } else if (rw.rwUtils.isIterable(data[name])) {
                        data[name] = rw.rwUtils.functionalizeJson(data[name]);
                    }
                }
            }

            return data;
        },

        /**
         *
         * @param cname     : cookie name
         * @returns string  : cookie value
         */
        getCookie: function (cname) {
            var name = cname + "=";
            var ca = document.cookie.split(';');
            for (var i = 0; i < ca.length; i++) {
                var c = ca[i].trim();
                if (c.indexOf(name) === 0) {
                    return c.substring(name.length, c.length);
                }
            }
            return "";
        },

        /**
         * Set cookie
         *
         * @param cname     :Cookie name
         * @param cvalue    :Cookie value
         * @param exdays    :Cookie expire day
         */
        setCookie: function (cname, cvalue, exdays) {
            var expires = "";
            if (exdays !== undefined) {
                var d = new Date();
                d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
                expires = "expires=" + d.toGMTString();
            }
            document.cookie = cname + "=" + cvalue + "; " + expires + "; Path=/";
        },

        /**
         * Update notification
         *
         * @param url     :URL Address for request
         */
        updateNotification: function (url) {
            if(rw['changeRole']){
                return false;
            }
            function setNotificationCountInTitle() {
                var countOfMsg = $('.notif-counter').text();
                if (countOfMsg !== "") {
                    document.title = '(' + countOfMsg + ') ' + rw.orginalPageTitle;
                } else {
                    document.title = rw.orginalPageTitle;
                }
            }

            if (rw.orginalPageTitle === null || rw.orginalPageTitle === undefined) {
                rw['orginalPageTitle'] = document.title;
            }

            checkNotifs();
            function checkNotifs() {
                var ajax = new ajaxGenerator({
                    url: url,
                    loading: false,
                    success: function (data) {
                        $("#notification-widget").replaceWith(data);
                        if (typeof(Storage) !== "undefined") {
                            addToLocalStorage("LastNotifData", data);
                            addToLocalStorage("lastNotifUpdate", Date.now());
                        }

                        setNotificationCountInTitle();
                    }
                });
                ajax.load();
                return false;
            }

            setNotificationCountInTitle();
        },

        /**
         * authentication Alert
         *
         * @param url     :URL Address for request
         */
        authenticationAlert: function (url) {
            checkhasAlert();
            function checkhasAlert() {
                var ajax = new ajaxGenerator({
                    url: url,
                    loading: false,
                    success: function (data) {
                        if (data) {
                            data = JSON.parse(data);
                            if (data.alert === true) {
                                rw.rwUtils.flashMessage('warning', data.message);
                            }
                        }
                    }
                });
                ajax.load();
                return false;
            }
        },

        /**
         * Set select2 to all page elements
         */
        select2: function ( elementId ) {
            if ( elementId ) {
                const element = $( elementId );
                if (!element.hasClass("select2-hidden-accessible")) {
                    // Select2 has not been initialized
                    if (element.prop('readonly') || element.data('readonly')) {
                        element.select2({readonly: 'readonly'});
                    } else {
                        try {
                            element.select2(rw.rwUtils.functionalizeJson(JSON.parse($(elementId).attr('data-config'))));
                        } catch (ex) {
                            element.select2({dir: $(elementId).parent().parent().data('direction') ? $(elementId).parent().parent().data('direction') : 'ltr'});
                        }
                    }
                }
            } else {
                $.each($(".select2-static"), function (index, item) {
                    if (!$(item).hasClass("select2-offscreen")) {
                        window.setTimeout(function() {
                            try {
                                $(item).select2(rw.rwUtils.functionalizeJson(JSON.parse($(item).attr('data-config'))));
                            } catch (ex) {
                                $(item).select2({dir: $(elementId).parent().parent().data('direction') ? $(elementId).parent().parent().data('direction') : 'ltr'});
                            }
                            if ($(item).prop('readonly') || $(item).data('readonly')) {
                                $(item).select2({readonly: 'readonly'});
                            }
                        }, 1);
                    }
                });
            }
        },

        /**
         * sync checkbox with its hidden input
         */
        syncCheckBox: function () {
            $.each($("input[type='checkbox']"), function () {
                if ($(this).attr("data-parent") !== undefined){
                    if ($("." + $(this).attr("data-parent")).val() == "on") {
                        $(this).prop("checked", true);
                    } else if ($("." + $(this).attr("data-parent")).val() == "off")
                    {
                        $(this).prop("checked", false);
                    }
                }
            });
        },

        /**
         * Add Verfiy to Form
         */
        formVerify : function(formName) {
            var $form = $("form[name='hhh']");
            var $table = [];
            $.each($form.serializeArray(),function(index,element){
                if(element.value.trim() == ""){
                    return ;
                }

                var hasIt = $table.filter(function(inp){
                    if (inp.name == element.name ){
                        return true;
                    }
                });
                if (hasIt.length != 0){
                    return false;
                }

                var id = $("*[name='" + element.name + "']").attr("id");
                var label = $("label",$("#" + id).closest(".form-group")).first().text().trim();
                var value = [];
                var input = $('*[name="' + element.name + '"]');
                $.each(input,function(){

                    if($(this).val().trim() == ""){
                        return ;
                    }

                    var type = $(this).attr("type");
                    if (type == "radio" ||  type == "checkbox"){
                        if ($(this).prop("checked")){
                            value.push($(this).val());
                        }
                    }else{
                        value.push($(this).val());
                    }

                });

                //var item = {"label"}
                element['label'] = label;
                element.value = value.join(" - ");
                $table.push(element);
            });

            $files = $("input[type='file']");
            $.each($files,function(){

                var label = $("label",$(this).closest(".form-group")).first().text().trim();
                var element = [];
                element['label'] = label;

                if ($(this)[0].files[0] != undefined){
                    var file = $(this)[0].files[0];

                    if (file.type == "image/jpeg" || file.type == "image/jpg"
                        || file.type == "image/png" || file.type == "image/gif")
                    {
                        var reader = new FileReader();
                        var $img = $("<img>").addClass("img-thumbnail").width(140);
                        reader.onload = function(e) {
                            $img.attr("src", e.target.result);
                            element.value = $img[0].outerHTML;
                            $table.push(element);
                        };
                        reader.readAsDataURL(file);
                    }else{
                        element['value'] = $(this).val();
                        $table.push(element);
                    }
                }
            });

            setTimeout(function(){
                $("#approve_tbl").remove();
                $tbl = $("<table></table>").addClass("table").attr("id","approve_tbl");
                $.each($table,function(index,element){
                    $tr = $("<tr></tr>");
                    $tr.append("<td class='col-lg-3'>" + element.label + "</td>");
                    $tr.append("<td>" + element.value + "</td>");
                    $tbl.append($tr);
                });
                $("button[type='button']" , $form).show();
                $form.children("div").hide();
                $(".clearfix").show();
                $form.prepend($tbl);
            },100)
        },

        /**
         * Add verify btn to form
         */
        addVerify : function(formName){
            var $form = $("form[name='" + formName + "']");
            if ($("#preview_" + formName).length == 0){
                var btn = $("<input type='button' id='preview_" + formName + "' class='btn btn-info' value='Pre Submit' />");
                btn.click(function(){
                    if ($("#preview_" + formName).attr("data-showPreview") == "do") {
                        $("#preview_" + formName).val("Pre Submit");
                        $("button[type='button']" , $form).hide();
                        $form.children("div").show();
                        $("#preview_" + formName).attr("data-showPreview","dont");
                        $("#approve_tbl").remove();
                    }
                    else{
                        rw.rwUtils.formVerify(formName);
                        $(this).attr("data-showPreview","do");
                        $(this).val("Edit");
                    }
                });
                $("button[type='button']" , $form).hide().after(btn);
            }
        },
        removePreventClick : function () {
            $('button').prop('disabled', false);
        },
        preventClick : function () {
            $('button').attr('disabled', 'disabled');
        },
        /**
         * Leave message
         */
        leaveMessage : function(){
            $(document).on("focus", "form", function(){
                window.leaving = false;
                if ($(this).data("form-dirty-data") === undefined) {
                    if ($(this).hasClass("noDirtyCheck")){
                        return;
                    } else {
                        $(this).data('form-dirty-data',$(this).serialize());
                        $(this).data('form-dirty',false);
                    }
                    $(this).change(function(){
                        if ($(this).data('form-dirty-data') === $(this).serialize()){
                            $(this).data('form-dirty',false);
                        } else {
                            $(this).data('form-dirty',true);
                        }
                    });
                }
            });

            $(document).on("submit", "form", function() {
                $(this).data('form-dirty', false);
            });

            window.onbeforeunload = function (e) {
                window.leaving = true;

                $("form").each(function() {
                    if ($(this).data('form-dirty')){
                        var message = "Your confirmation message goes here.";
                        e = e || window.event;

                        if (e) {
                            e.returnValue = message;
                        }

                        return message;
                    }
                });
            };
        },

        /**
         * Run function from url
         */
        runUrlFunc: function(params){
            var self = this;

            self.triggerTransformClick = function(rowEl, transId) {
                $(rowEl).find("a[href*='/transform/"+transId+"/']").each(function(index, element) {
                    if($(element).hasClass('transform-btn')) {
                        $(element).trigger('click');
                    } else {
                        window.location.href = $(element).attr('href');
                    }
                });
            };

            self.triggerAssignmemtClick = function(rowEl, actionType) {
                $(rowEl).find(".transform-btn[id^='"+actionType+"']").each(function(index, element) {
                    $(element).trigger('click');
                });
            };

            self.doTransform = function () {
                if(
                    !params.docId ||
                    !params.transId
                ) {
                    return;
                }

                $('#list tr td:nth-child(2)').each(function (index, element) {
                    if($(element).text() == params.docId) {
                        self.triggerTransformClick($(element).closest('tr'), params.transId);
                    }
                });
            };

            self.doAssignment = function () {
                if(
                    !params.docId ||
                    !params.actionType
                ) {
                    return;
                }

                $('#list tr td:nth-child(2)').each(function (index, element) {
                    if($(element).text() == params.docId) {
                        self.triggerAssignmemtClick($(element).closest('tr'), params.actionType);
                    }
                });
            };

            if(!params._do) {
                return;
            }

            switch (params._do ) {
                case 'transform':
                    self.doTransform();
                    break;
                case 'assignment':
                    self.doAssignment();
                    break;
            }
        }
    }
};

module.exports = rw;